import { createFileRoute } from '@tanstack/react-router'

import { UserListPage } from '@/systems/user-management'

export const Route = createFileRoute('/user-management/')({
  component: UserListPage,
})
